export default __webpack_public_path__ + "static/media/arch_des_en.73f7c1a0.png";